import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../icons';
import GlobalSearch from "../../containers/Header/GlobalSearch";
import * as CommonUtil from '../../common/util';
import UserImage from '../UserImage/index';
import { selectSessionContextOidc } from '@container/AdminPanel/features/users/usersSelectors';
import { useSelector } from 'react-redux';

import { PATHS } from '../../router/paths';

const TopRightHeader = (props) => {
    const sessionContext = useSelector(selectSessionContextOidc);
    const userView = sessionContext?.userView;
    const userPermission = userView?.permissions;
    const [currentActive, setCurrentActive] = React.useState("");
    const navigate = useNavigate();

    const onHeaderClick = (id, clickedTab) => {
        if ($(".headerRight li").is('[name]')) {
            $(".headerRight li").removeAttr("name");
        }
        setCurrentActive(clickedTab);
        props.setActiveTopHeader({ activeHeader: clickedTab });
        $(`#${id}`).attr('name', clickedTab);
    };

    const handleCreateWorkkard = () => {
        navigate(PATHS.WORKKARD_CREATE, {
            state: { returnUrl: `${window.location.pathname}${window.location.search}${window.location.hash}` }
        });
    };

    const { headerContext } = props;
    let profileThumbImageUrl = CommonUtil.renderStaticImage("/images/default_user.svg");
    let canCreateWorkkard = false;
    let userProfileName = '';
    if (sessionContext && userView) {
        profileThumbImageUrl = userView.profileImage ? userView.profileImage : profileThumbImageUrl;
        canCreateWorkkard = userPermission?.can_create_workkard;
        userProfileName = `${userView?.firstName} ${userView?.lastName}`;
    }

    return (
        <div className="headerRight alignMiddle">
            {!sessionContext.IsAuditUser && <div id="globalSearchdiv" className="globalSearch"><GlobalSearch /></div>}
            <ul>
                {
                    CommonUtil.mobileAndTabletcheck() &&
                    <li onClick={() => props.onHamburgerClick(true)} data-test="profilePanel">
                        <div className="leftToggleNav">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </li>
                }
                {canCreateWorkkard && !CommonUtil.mobileAndTabletcheck() && <li><a id="lnkCreateWorkkardNew" onClick={() => handleCreateWorkkard()} className="pointer btn buttonGradient">Create workkard</a></li>}
                {headerContext && headerContext.accessableOrgIds && headerContext.accessableOrgIds.length > 0 &&
                    <li id="orgAccessPanelShow" onClick={() => onHeaderClick("orgAccessPanelShow", "orgaccess")}>
                        <a title="Organization Access" className="orgAccessIcon"><svg className="icon"><use xlinkHref="/SVG/exzeo2x-icon.svg#org-access"></use></svg></a>
                    </li>
                }
                {/* {headerContext && headerContext.associatedPartyEnabled == "true" &&
                    <li id="partyGlobalIcon" onClick={() => onHeaderClick("partyGlobalIcon","parties")}><a href="javascript:void(0);" id="associatePartiesBtn" className="partiesIcon" title='Parties'><svg className="icon"><use xlinkHref="/SVG/exzeo2x-icon.svg#parties"></use></svg></a></li >
                } */}
                {!sessionContext.IsAuditUser && <li id="refreshBtn" onClick={() => onHeaderClick("refreshBtn", "notification")}>
                    <a className="notification" title="Notifications">
                        <Icon name="notification" className="icon" />
                        <div className="activities_notificationlink">
                            <div className="new_updates">
                                <span className="notification_number">
                                    <span id="updatecount">
                                    </span>
                                </span>
                            </div>
                        </div>
                    </a>
                </li>}


                <li id="profilePanel" onClick={() => onHeaderClick("profilePanel", "actioncenter")} data-test="profilePanel">
                    <UserImage className="profileImage" profileUrl={profileThumbImageUrl} profileName={userProfileName} />
                </li>
            </ul>
        </div>
    );
};

export default TopRightHeader;